import React, {Component} from 'react';
import "../NavigationPage.css";
import TestMenuContent from "./../TestMenuContent";

class NavigationPage2 extends Component {

    render() {
        return (

            <div className="footer-navigation-content">
                <div className="footer-navigation-div">
                    <div className="spacer"></div>
                    {/*ご利用ガイド*/}

                    <div id="footer-menu2-item1">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            製造
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu2-item2">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            全体の流れ
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                    <div id="footer-menu2-item3">
                        <div className="spacer"></div>
                        <div className="title-1 text-align-left">
                            注文に必要なGERBER DATA
                        </div>
                        <hr/>
                        <div className="menu-content">
                            <TestMenuContent/>
                        </div>
                    </div>

                </div>
            </div>
        )
    }

}
export default NavigationPage2;


// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/FooterNavigationPages/MenuContentPages/NavigationPage2.js